module.exports = __webpack_public_path__ + "static/media/ao.33d397a8.svg";